import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cc-stripe': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M492.4 220.8c8.7 0 18 6.7 18 22.7h-36.7c0-16 9.8-22.7 18.7-22.7zM375 223.4c12.9-0.1 21.9 14.5 21.9 33.1 0 19.1-8.8 33.4-21.9 33.4-8.3 0-13.3-3-16.8-6.7l-0.2-52.8c3.7-4.1 8.8-7 17-7zM528 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h480zM122.2 281.1c0-42.3-54.3-34.7-54.3-50.7 0-5.5 4.6-7.7 12.1-7.7 10.8 0 24.5 3.3 35.3 9.1v-33.4c-11.8-4.7-23.5-6.5-35.3-6.5-28.8 0-48 15-48 40.2 0 39.3 54 32.9 54 49.9 0 6.6-5.7 8.7-13.6 8.7-11.8 0-26.9-4.9-38.9-11.3v33.9c13.2 5.7 26.6 8.1 38.8 8.1 29.6-0.2 49.9-14.7 49.9-40.3zM191 224.5v-30.3h-26.9v-30.8l-34.7 7.4-0.2 113.9c0 21 15.8 36.5 36.9 36.5 11.6 0 20.2-2.1 24.9-4.7v-28.9c-4.5 1.8-27 8.3-27-12.6v-50.5h27zM265 226.9v-32.7h-0.1c-4.7-1.7-21.3-4.8-29.6 10.5l-2.2-10.5h-30.7v124.5h35.5v-84.4c8.4-11 22.6-8.9 27.1-7.4zM309.1 318.7v-124.5h-35.7v124.5h35.7zM309.1 175.8v-28.9l-35.7 7.6v28.9zM383.2 321.3c25.4-0.1 48.6-20.5 48.6-65.6 0-41.3-23.5-63.8-48.4-63.8-13.9 0-22.9 6.6-27.8 11.1l-1.8-8.8h-31.3v165.8l35.5-7.5 0.1-40.2c5.1 3.7 12.7 9 25.1 9zM543.6 269.8c0.1-2 0.4-9.4 0.4-12.9 0-36.4-17.6-65.1-51.3-65.1-33.8 0-54.3 28.7-54.3 64.9 0 42.8 24.2 64.5 58.8 64.5 17 0 29.7-3.9 39.4-9.2v-28.6c-9.7 4.9-20.8 7.9-34.9 7.9-13.8 0-26-4.9-27.6-21.5h69.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-stripe.js
// module id = 751
// module chunks = 0